import React from 'react';
import './ValidationWarningModal.css';

interface ValidationWarningModalProps {
  emptyFieldsCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const ValidationWarningModal: React.FC<ValidationWarningModalProps> = ({ 
  emptyFieldsCount, 
  onConfirm, 
  onCancel 
}) => {
  return (
    <div className="validation-warning-overlay">
      <div className="validation-warning-modal">
        <div className="warning-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M12 9V13M12 17H12.01M4.93 4.93L19.07 19.07M7.76 2H16.24C17.8 2 18.77 3.08 19.03 4.5L21.77 17.5C22.03 18.92 21.03 20 19.47 20H4.53C2.97 20 1.97 18.92 2.23 17.5L4.97 4.5C5.23 3.08 6.2 2 7.76 2Z" 
              stroke="#F59E0B" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        
        <h2 className="warning-title">Incomplete Data Detected</h2>
        
        <div className="warning-message">
          <div className="field-count">
            <span className="count-number">{emptyFieldsCount}</span>
            <span className="count-label">
              mapped field{emptyFieldsCount !== 1 ? 's' : ''} {emptyFieldsCount !== 1 ? 'are' : 'is'} missing values
            </span>
          </div>
          
          <p className="warning-description">
            Please review all sections to ensure data completeness before processing.
          </p>
          
          <p className="warning-question">
            Do you want to continue anyway?
          </p>
        </div>
        
        <div className="warning-actions">
          <button 
            className="btn-review" 
            onClick={onCancel}
          >
            Review Fields
          </button>
          <button 
            className="btn-continue" 
            onClick={onConfirm}
          >
            Continue Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationWarningModal;